import { useState } from "react";
import { LocateFixed, Loader2 } from "lucide-react";
import { toast } from "sonner";

export const GEO_RX = /^-?\d{1,3}\.\d+,-?\d{1,3}\.\d+$/;
export const locLabel = (v) => (GEO_RX.test(v || "") ? "Din placering" : v || "");
export const locInput = (prev, next) => (GEO_RX.test(prev || "") ? next.replace("Din placering", "").replace(/^Din placerin?g?$/, "") : next);

const ERRORS = { 1: "Du har ikke givet adgang til din placering. Tillad placering i browseren, eller skriv postnummer eller by.", 2: "Din placering kunne ikke findes. Skriv postnummer eller by.", 3: "Det tog for lang tid at finde din placering. Prøv igen." };

export const MyLocationButton = ({ onLocate, testid = "my-location-button", className = "" }) => {
  const [busy, setBusy] = useState(false);
  const locate = () => {
    if (!navigator.geolocation) {
      toast.error("Din browser understøtter ikke placering. Skriv postnummer eller by.");
      return;
    }
    setBusy(true);
    navigator.geolocation.getCurrentPosition(
      (pos) => { setBusy(false); onLocate(`${pos.coords.latitude.toFixed(3)},${pos.coords.longitude.toFixed(3)}`); },
      (err) => { setBusy(false); toast.error(ERRORS[err.code] || ERRORS[2]); },
      { enableHighAccuracy: false, timeout: 10000, maximumAge: 300000 },
    );
  };
  return (
    <button type="button" onClick={locate} disabled={busy} data-testid={testid}
      className={`inline-flex items-center gap-1.5 text-sm font-semibold text-[#087F72] hover:text-[#065F56] disabled:opacity-60 ${className}`}>
      {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <LocateFixed className="h-4 w-4" />}Brug min placering
    </button>
  );
};
